// SCRUM-74 (parte 2): el backend cachea las URLs presignadas por proceso, pero con
// varios workers cada proceso firma su propio juego → el src cambiaría entre
// refetches aunque la imagen sea la misma, y Chrome re-pinta/re-descarga. Este
// guard conserva la primera URL vista mientras el OBJETO (URL sin la query de
// firma) no cambie, con caducidad de seguridad: una presigned muere a la hora, y
// conservarla para siempre rompería thumbnails re-montados en sesiones largas.

const MAX_KEEP_MS = 40 * 60 * 1000; // por debajo de la ventana del 80% del TTL del BE

const seen = new Map(); // baseUrl -> { url, ts }
const SEEN_MAX = 4096;

export function stripUrlQuery(url) {
  if (typeof url !== "string" || !url) return null;
  const i = url.indexOf("?");
  return i === -1 ? url : url.slice(0, i);
}

// Devuelve una URL estable para el mismo objeto: la primera vista, hasta caducar.
export function stableImageUrl(nextUrl, now = Date.now()) {
  const base = stripUrlQuery(nextUrl);
  if (!base) return nextUrl;
  const entry = seen.get(base);
  if (entry && now - entry.ts < MAX_KEEP_MS) return entry.url;
  if (seen.size >= SEEN_MAX) seen.clear();
  seen.set(base, { url: nextUrl, ts: now });
  return nextUrl;
}

// Aplica el guard al campo de imagen de una lista (productos del POS).
export function withStableImageUrls(items, field = "image_path", now = Date.now()) {
  if (!Array.isArray(items)) return items;
  return items.map((it) => {
    const url = it?.[field];
    const stable = stableImageUrl(url, now);
    return stable === url ? it : { ...it, [field]: stable };
  });
}

// Solo para tests.
export function _resetStableImagesForTests() {
  seen.clear();
}
